<template>
    <div>
        <h2>Waren fremde Fahrzeuge beteiligt?</h2>
        <div class="ion-text-right ion-padding-top">
            <chat-radio-group
                v-if="isVisible"
                v-model="answer"
                :radios="radios"
            />
            <div v-if="answer === 'Ja'" class="ion-margin-top">
                <ion-grid>
                    <ion-row>
                        <ion-col size="10" offset="2">
                            Gib am Unfall beteiligte fremde Fahrzeuge an
                        </ion-col>
                    </ion-row>
                </ion-grid>
                <div v-for="(entry, key) in beteiligte" :key="key">
                    <div class="c-chatbubble -danger-tint ion-margin-top">
                        <div class="c-chatbubble__buttons">
                            <ion-button
                                class="-round"
                                fill="clear"
                                @click="beteiligte.splice(key, 1)"
                            >
                                <ion-icon
                                    name="close-circle-outline"
                                    slot="icon-only"
                                ></ion-icon>
                            </ion-button>
                        </div>
                        <b
                            >{{ entry.kfzmarke }} {{ entry.kmstand }}
                            <span v-if="entry.kmstand">km</span></b
                        ><br />
                        {{ entry.kennzeichennummer }}
                    </div>
                </div>
                <ion-button
                    fill="outline"
                    class="-round ion-margin-top ion-margin-bottom"
                    @click="openBeteiligteFahrzeugeModal"
                    ><ion-icon name="add" slot="start" />Fahrzeug
                    hinzufügen</ion-button
                >
                <br />
                <ion-button
                    class="-round -add-padding ion-margin-top"
                    :disabled="beteiligte.length === 0"
                    @click="
                        $emit('change', [
                            {
                                id: 'hasBeteiligteFahrzeuge',
                                value: answer,
                            },
                            { id: 'beteiligteFahrzeuge', value: beteiligte },
                        ])
                    "
                    >Weiter</ion-button
                >
            </div>
        </div>
    </div>
</template>

<script>
import ChatRadioGroup from "@/components/ChatRadioGroup";
import BeteiligteFahrzeugeModal from "@/components/schadensmeldung/BeteiligteFahrzeugeModal";

export default {
    components: { ChatRadioGroup },
    props: {
        isVisible: {
            required: false,
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            radios: [{ value: "Ja" }, { value: "Nein" }],
            answer: "",
            beteiligte: [],
        };
    },
    watch: {
        answer(value) {
            if (value === "Nein") {
                this.$emit("change", [
                    {
                        id: "hasBeteiligteFahrzeuge",
                        value: value,
                    },
                    { id: "beteiligteFahrzeuge", value: [] },
                ]);
            }
        },
    },
    methods: {
        openBeteiligteFahrzeugeModal() {
            this.$ionic.modalController
                .create({
                    component: BeteiligteFahrzeugeModal,
                    componentProps: {
                        parent: this,
                    },
                    backdropDismiss: false,
                })
                .then((a) => {
                    a.onDidDismiss().then((result) => {
                        if (result.data && result.data.beteiligteFormData) {
                            this.beteiligte.push(
                                result.data.beteiligteFormData
                            );
                        }
                    });
                    a.present();
                });
        },
    },
};
</script>

<style lang="scss" scoped></style>
